import axios from 'axios';
import ElementUI from "element-ui";
import router from "./router";

// axios.defaults.baseURL = 'http://localhost:8801'
// axios.defaults.baseURL = 'https://yc.swuyu.cn'
// 创建axios实例
var instance = axios.create({timeout: 10000 * 12});
instance.interceptors.request.use(config => {
    if (config.url === '/admin/login' || config.url === '/active') {
      return config
    }
    if (localStorage.getItem('token')) {
      config.headers.token = localStorage.getItem('token')
    } else {
      ElementUI.Message.error('请重新登录')
      router.push({name: 'login'});
      return
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })
instance.interceptors.response.use(response => {
    // 和后端token失效返回码约定100
    if (response.data.code == 100) {
      ElementUI.Message.error('请重新登录')
      // 引用elementui message提示框
      //清除token
      localStorage.removeItem('token');
      //跳转
      router.push({name: 'login'});
    } else {
    return response
    }
  },
  error => {
    return Promise.reject(error);
  })
export default instance;



// WEBPACK FOOTER //
// ./src/http.js